<mijn-login-template title="Auth0 Login">
    @if (auth0isAuthenticated() | async) {
        <ap-card>
            <div>
                <div><h2>Welkom bij OneApp - Web</h2></div>
                <div>
                    <strong>authenticated: </strong> <span>{{ authenticated }}</span>
                </div>
                <div>
                    <strong>accessToken valid: </strong> <span>{{ accessToken }}</span>
                </div>
                <div>
                    <strong>claimExp valid: </strong> <span> {{ claimExp }}</span>
                </div>
                @if (auth.user$ | async; as user) {
                    <div>
                        <strong>Email: </strong> <span>{{ user.email }}</span>
                    </div>
                    <div>
                        <strong>Name: </strong> <span>{{ user.name }}</span>
                    </div>
                    <div>
                        <strong>Party ID: </strong> <span>{{ user['http://asnbank.nl/party_id'] }}</span>
                    </div>
                    <div>
                        <strong>Sub: </strong> <span>{{ user.sub }}</span>
                    </div>
                    <div>
                        <strong>Email verified: </strong> <span>{{ user.email_verified }}</span>
                    </div>
                    <div>
                        <strong>Updated at: </strong> <span>{{ user.updated_at }}</span>
                    </div>
                }
                <div>
                    <br /><br />
                    <ap-button (onClick)="auth0logout()">Uitloggen</ap-button>
                </div>
                @if (rawIdToken) {
                    <div>
                        <strong>Raw ID Token (JWT):</strong>
                        <p style="word-break: break-all; font-size: 0.75rem">{{ rawIdToken }}</p>
                    </div>
                }
            </div>
        </ap-card>
    } @else {
        <ap-card title="" class="ap-margin-bottom-4">
            <p>Nog niet aangemeld?</p>
            <div>
                <ap-button (onClick)="emailSignupRedirect()">Aanmelden voor nieuwe login</ap-button>
            </div>
            <p>Aangemeld, meteen inloggen</p>
            <div>
                <ap-button (onClick)="emailPasskeyLogin()">Inloggen</ap-button>
            </div>
        </ap-card>
    }
</mijn-login-template>
